import React, { useState } from 'react';
import './adminpanel.css';

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('horoscopeUpload');

  const horoscopeUploadUrl = "/horoscopeupload";  
  const blogUploadUrl = "/blogupload";  
  const faqmanagerUrl = "/faqmanager";            

  const openInNewTab = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="admin-dashboard">
      <div className="navbar">
        <div
          className={`navbar-item ${activeTab === 'horoscopeUpload' ? 'active' : ''}`}
          onClick={() => setActiveTab('horoscopeUpload')}
        >
          Horoscope Upload
        </div>
        <div
          className={`navbar-item ${activeTab === 'blogUpload' ? 'active' : ''}`}
          onClick={() => setActiveTab('blogUpload')}
        >
          Blog Upload
        </div>
        <div
          className={`navbar-item ${activeTab === 'faqUpload' ? 'active' : ''}`}
          onClick={() => setActiveTab('faqUpload')}
        >
          FAQ Upload
        </div>
      </div>

      <div className="admin-content">
        {activeTab === 'horoscopeUpload' && (
          <div className="uploads-section">
            <h2>Horoscope Upload</h2>
            <button onClick={() => openInNewTab(horoscopeUploadUrl)}>Open Horoscope Upload</button>
          </div>
        )}

        {activeTab === 'blogUpload' && (
          <div className="uploads-section">
            <h2>Blog Upload</h2>
            <button onClick={() => openInNewTab(blogUploadUrl)}>Open Blog Upload</button>
          </div>
        )}

        {activeTab === 'faqUpload' && (
          <div className="uploads-section">
            <h2>FAQ Upload</h2>
            <button onClick={() => openInNewTab(faqmanagerUrl)}>Open FAQ Upload</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
